import colors from './colors.js';
import sizes from './sizes.js';
import { space } from './space.js';
import borders from './borders.js';
import charts from './charts.js';

const baseTheme = {
    breakpoints: [600, 768, 1024, 1280],
    rootFontSize: '12px',
    colors,
    sizes,
    space,
    borders,
    charts
};

export { baseTheme as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFzZVRoZW1lLmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdGhlbWUvYmFzZVRoZW1lLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBjb2xvcnMsIHsgQ29sb3JzIH0gZnJvbSAnLi9jb2xvcnMnO1xuaW1wb3J0IHNpemVzLCB7IFNpemVzIH0gZnJvbSAnLi9zaXplcyc7XG5pbXBvcnQgc3BhY2UsIHsgU3BhY2UgfSBmcm9tICcuL3NwYWNlJztcbmltcG9ydCBib3JkZXJzLCB7IEJvcmRlcnMgfSBmcm9tICcuL2JvcmRlcnMnO1xuaW1wb3J0IGNoYXJ0cywgeyBDaGFydHMgfSBmcm9tICcuL2NoYXJ0cyc7XG5cbmV4cG9ydCB0eXBlIEJhc2VUaGVtZSA9IHtcbiAgYnJlYWtwb2ludHM6IG51bWJlcltdO1xuICByb290Rm9udFNpemU6IHN0cmluZztcbiAgY29sb3JzOiBDb2xvcnM7XG4gIHNpemVzOiBTaXplcztcbiAgc3BhY2U6IFNwYWNlO1xuICBib3JkZXJzOiBCb3JkZXJzO1xuICBjaGFydHM6IENoYXJ0cztcbn07XG5cbmNvbnN0IGJhc2VUaGVtZTogQmFzZVRoZW1lID0ge1xuICBicmVha3BvaW50czogWzYwMCwgNzY4LCAxMDI0LCAxMjgwXSxcbiAgcm9vdEZvbnRTaXplOiAnMTJweCcsXG4gIGNvbG9ycyxcbiAgc2l6ZXMsXG4gIHNwYWNlLFxuICBib3JkZXJzLFxuICBjaGFydHNcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGJhc2VUaGVtZTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFnQkEsTUFBTSxTQUFTLEdBQWM7SUFDM0IsV0FBVyxFQUFFLENBQUMsR0FBRyxFQUFFLEdBQUcsRUFBRSxJQUFJLEVBQUUsSUFBSSxDQUFDO0FBQ25DLElBQUEsWUFBWSxFQUFFLE1BQU07SUFDcEIsTUFBTTtJQUNOLEtBQUs7SUFDTCxLQUFLO0lBQ0wsT0FBTztJQUNQLE1BQU07Ozs7OyJ9
